import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';
import { SwatchValidationError } from './SwatchValidationError';

export const { MissingHexValueError } = errorFactory(
  'MissingHexValueError',
  SwatchValidationError
);

/**
 * Error thrown when a swatch is missing its hexValue property.
 *
 * This occurs when hexValue is null, undefined, or an empty string.
 */
export type MissingHexValueError = InstanceTypeOf<typeof MissingHexValueError>;
